import { Col, Row, Tooltip } from 'antd';
import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { ReactComponent as LeftArrowIcon } from '../../../assets/images/svg/i_left_arrow.svg';
import { ReactComponent as HisArrowIcon } from '../../../assets/images/svg/His_Back_Arrow.svg';

const PageHeaderRedesign = ({
  rightComponent: RightComponent, leftComponent: LeftComponent, pageTitle, backUrl, titleRightButton,
  colSize, customeClass, footerComponent: FooterComponent, offsetClass,
  isPreAuthNewDesignEnabled, isNewadmission, id, isShowAdmissionForm,
  ...args }: any): ReactElement => {
  const history = useHistory();

  const leftArrowClickHandler = (): void => {
    if (typeof (backUrl) === 'function') {
      backUrl();
    } else {
      if (backUrl === '/abdm/concent-list') {
        history.goBack();
      }
      history.push(backUrl);
    }
  };

  const pageTitleType = typeof (pageTitle);
  return (
    <div className={isPreAuthNewDesignEnabled ? 'new-design-tab-header' : 'tab-header'}>
      <Row gutter={GUTTOR_SPACE} className={'align-flex-start ' + (customeClass ? customeClass : '')}>
        {(pageTitle || backUrl) &&
          <Col md={colSize ? colSize : 6} style={{ display: 'flex', alignItems: 'center' }}>
            {backUrl && <Tooltip title="Back">
              {isPreAuthNewDesignEnabled ?
                <HisArrowIcon
                  data-testid="back"
                  onClick={leftArrowClickHandler}
                  className="mr-10 fill-primary v-align-middle mouse-pointer"
                />
                : <LeftArrowIcon
                  data-testid="back"
                  onClick={leftArrowClickHandler}
                  className="mr-10 fill-primary v-align-middle mouse-pointer"
                />}
            </Tooltip>}
            {pageTitleType === 'string' ?
              <h1 className="m-0 text-elipsis mr-10 page-title" title={pageTitle}>{pageTitle}</h1> :
              <h1 className="m-0 text-elipsis mr-10">{pageTitle}</h1>
            }
            {
              titleRightButton &&

              titleRightButton}

          </Col>
        }
        <Col
          md={
            pageTitle || backUrl
              ? colSize
                ? 24 - colSize
                : (isPreAuthNewDesignEnabled && isNewadmission)
                  ? 10
                  : 10
              : 24
          }
          xxl={
            pageTitle || backUrl
              ? colSize
                ? 24 - colSize
                : (isPreAuthNewDesignEnabled && isNewadmission)
                  ? 12
                  : 8
              : 24
          }

          className={`header-right ${offsetClass && 'move-right'}`}>
          {
            LeftComponent ? <LeftComponent {...args} /> : null
          }
        </Col>
        <Col
          md={
            pageTitle || backUrl
              ? colSize
                ? 24 - colSize
                : (isPreAuthNewDesignEnabled && isNewadmission)
                  ? (id === 0 || isShowAdmissionForm ? 8 : 4)
                  : 8
              : 24
          }
          xxl={
            pageTitle || backUrl
              ? colSize
                ? 24 - colSize
                : (isPreAuthNewDesignEnabled && isNewadmission)
                  ? (id === 0 ? 8 : 6)
                  : 6
              : 24
          }

          className={`header-right ${offsetClass && 'move-right'}`}>
          {
            RightComponent ? <RightComponent {...args} /> : null
          }
        </Col>
      </Row>
      {FooterComponent && <FooterComponent />}
    </div>
  );
};

export default PageHeaderRedesign;
